import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import React, { useContext } from 'react';
import _get from 'lodash/get';
import { oneOfType, string, arrayOf, func, objectOf } from 'prop-types';
import { TtpContext, formatTtp as _formatTtp } from '../../utils/ttp/index.js';

var propTypes = {
  /** Path of message(s) to be retrieved from TtpContext object.
   * Can accept multiple ids as an array in necessary
   */
  id: oneOfType([string, arrayOf(string)]).isRequired,
  /** React compositional child.
   * Expects a function that accepts substrings and returns a component */
  children: func,
  /** Object properties are used for substitution.
   * Values are substituted into message based on key.
   * Can accept array of objects in case multiple ids exist */
  substrings: oneOfType([objectOf(oneOfType([string, func])), arrayOf(objectOf(oneOfType([string, func])))])
};

/* istanbul ignore next */
var defaultProps = {
  children: null,
  substrings: {}
};

/**
 * Retrieves and renders one or more TTP messages from TtpContext.
 * @extends {Component<Props>}
 */
var TtpContent = function TtpContent(_ref) {
  var id = _ref.id,
    children = _ref.children,
    substrings = _ref.substrings;
  var context = useContext(TtpContext);
  var message = Array.isArray(id) ? id.map(function (x) {
    return _get(context, x);
  }) : _get(context, id);

  // if user passed in array of ids
  if (Array.isArray(message)) {
    var formattedMessages = message.map(function (msg, idx) {
      if (Array.isArray(substrings)) {
        return _formatTtp(msg, substrings[idx]);
      }
      return _formatTtp(msg, substrings);
    });
    if (typeof children === 'function') {
      return children.apply(void 0, _toConsumableArray(formattedMessages));
    }
    return formattedMessages.join(' ');
  }
  // else
  var formattedMessage;
  if (Array.isArray(substrings)) {
    formattedMessage = _formatTtp(message, substrings[0]);
  } else {
    formattedMessage = _formatTtp(message, substrings);
  }
  if (typeof children === 'function') {
    return children(formattedMessage);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, formattedMessage);
};
TtpContent.propTypes = propTypes;
TtpContent.defaultProps = defaultProps;

export { TtpContent as default };
